<template>
  <v-container>
    <material-card :title="Data.exam_name" :text="'Question available: ' + Data.questions_count " color="green">

             

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container py-0>


   <v-flex md12>
          <!-- <v-text-field  v-model="excel" label="Upload Questions" @click='pickExcel' prepend-icon='attach_file' class="green-input"></v-text-field> -->
                <input
                  type="file"
                  ref="excelFile"
                  @change="importExcel($event)"
                >
                  </v-flex>


          <v-layout wrap>
            <v-flex xs12 text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success"
                @click="onClickButton"
              >{{ Item.submitText }}</v-btn>

              <v-btn class="mx-2 font-weight-light" color="info" @click="closeQuestionModal">Close</v-btn>
              <v-btn class="mx-2 font-weight-light" color="primary" @click="increaseQuestion">Add more</v-btn>
              <v-btn class="mx-2 font-weight-light" color="danger" @click="resetQuestions">Reset</v-btn>
            </v-flex>
          </v-layout>


          <v-layout wrap v-for="(question, index) in questions" :key="index">
            <v-flex md12>
              <v-text-field
                type="text"
                label="Question"
                class="green-input"
                v-model="questions[index].question"
                prepend-icon="text_fields"
                :rules="questionRule"
              />
            </v-flex>

            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 1"
                class="green-input"
                v-model="questions[index].option1"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 2"
                class="green-input"
                v-model="questions[index].option2"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 3"
                class="green-input"
                v-model="questions[index].option3"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 4"
                class="green-input"
                v-model="questions[index].option4"
                prepend-icon="text_fields"
                :rules="optionRule"
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 5"
                class="green-input"
                v-model="questions[index].option5"
                prepend-icon="text_fields"
               
              />
            </v-flex>
            <v-flex md12>
              <v-text-field
                type="text"
                label="Option 6"
                class="green-input"
                v-model="questions[index].option6"
                prepend-icon="text_fields"
               
              />
            </v-flex>
            <v-flex md12>
              <b>Correct Answer</b>
              <!-- <v-radio-group v-model="questions[index].correct_answer" row :rules="correctAnsRule">
                <v-radio label="Option 1" value="1"></v-radio>
                <v-radio label="Option 2" value="2"></v-radio>
                <v-radio label="Option 3" value="3"></v-radio>
                <v-radio label="Option 4" value="4"></v-radio>
                <v-radio label="Option 5" value="5"></v-radio>
                <v-radio label="Option 6" value="6"></v-radio>
              </v-radio-group> -->
               <v-layout wrap>
                <v-flex md2>
                    <v-checkbox  
                    true-value="'1'"
                    :value=1
                    v-model="questions[index].correct_answer"    
                    label="Option 1"          
                  ></v-checkbox>
                </v-flex>
                  <v-flex md2>
                     <v-checkbox 
                    true-value="'2'"
                    :value=2
                    v-model="questions[index].correct_answer2"
                    label="Option 2"
                  ></v-checkbox>
                </v-flex>
                  <v-flex md2>
                     <v-checkbox 
                      true-value="'3'"
                      :value=3
                      v-model="questions[index].correct_answer3"
                    label="Option 3"
                  ></v-checkbox>
                  </v-flex>
                  <v-flex md2>

                     <v-checkbox 
                    true-value="'4'"
                      :value=4
                      v-model="questions[index].correct_answer4"
                    label="Option 4"
                  ></v-checkbox>
                  </v-flex>              
                  <v-flex md2>
                     <v-checkbox
                  true-value="'5'"
                      :value=5
                      v-model="questions[index].correct_answer5"
                    label="Option 5"
                  ></v-checkbox>
                </v-flex>
                  <v-flex md2>
                     <v-checkbox
                     true-value="'6'"
                      :value=6
                      v-model="questions[index].correct_answer6"
                    label="Option 6"
                  ></v-checkbox>
                </v-flex>
               </v-layout>               
                   
                             
            </v-flex>
            
            <v-flex md12>
              <b>Explanation</b>
               <v-textarea
                  name="input-7-1"
                  label="Explanation Text"
                  value=""
                  prepend-icon="text_fields"
                  hint="Explanation Text"
                   v-model="questions[index].explanation_text"
                ></v-textarea>
        
            </v-flex>
            <v-flex md12>
          <v-text-field  v-model="explanation" label="Explanation" @click='pickThumbnail' prepend-icon='attach_file' class="green-input"></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="explanation"
						accept="image/*"
						@change="onThumbnailPicked($event, index)"
					>
            </v-flex>

     


          </v-layout>

        </v-container>
      </v-form>
    </material-card>
  </v-container>
</template>

<script>

import xlsx from "xlsx";
export default {
  props: {
    Data: Object,
    QuestionNumber: Number,
  },
  data() {
    return {
      Item: {
        title: 'Add new question',
        subTitle: 'Please fill all fields',
        submitText: 'Submit'
      },
      checked:true,
      valid: true,
      explanation: '',
      excelQuestions: [],
      excel: '',
      questions: [
        {
          question: null,
          option1: null,
          option2: null,
          option3: null,
          option4: null,
          option5: null,
          option6: null,
          correct_answer: null,
          correct_answer2: null,
          correct_answer3: null,
          correct_answer4: null,
          correct_answer5: null,
          correct_answer6: null,
          explanation_text: null
        }
      ],
      que: {
          question: null,
          option1: null,
          option2: null,
          option3: null,
          option4: null,
          option5: null,
          option6: null,
          correct_answer: null,
          correct_answer2: null,
          correct_answer3: null,
          correct_answer4: null,
          correct_answer5: null,
          correct_answer6: null,
          explanation_text: null
        },
      questionRule: [v => !!v || 'Question is required.'],
      optionRule: [v => !!v || 'Option is required.'],
      correctAnsRule: [v => !!v || 'Option is required.']
    };
  },
  watch: {
    QuestionNumber: function() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.question = {}
  },
  methods: {
    resetQuestions () {
      this.$refs.form.reset()
      this.$refs.excelFile.value=null;
this.questions = [
        {
          question: null,
          option1: null,
          option2: null,
          option3: null,
          option4: null,
          option5: null,
          option6: null,
          correct_answer: null,
          correct_answer2: null,
          correct_answer3: null,
          correct_answer4: null,
          correct_answer5: null,
          correct_answer6: null,
          explanation_text: null
        }
      ]
    },
    onClickButton(event) {
     // if (this.$refs.form.validate()) {
        this.$emit('emitted',  this.questions);
     // }
    },
    increaseQuestion () {
      this.questions.push({
          question: null,
          option1: null,
          option2: null,
          option3: null,
          option4: null,
          option5: null,
          option6: null,
          correct_answer: null,
          correct_answer2: null,
          correct_answer3: null,
          correct_answer4: null,
          correct_answer5: null,
          correct_answer6: null,
          explanation_text: null
        })
    },


    importExcel(e) {   
      const files = e.target.files;     
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls or xlsx format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          this.questions = [];
          // Edit data
          for (var i = 0; i < ws.length; i++) {             
            // let ca = ws[i].correct_answer
            // if (ws[i].correct_answer === 'A')
            //   ca = 1
            // if (ws[i].correct_answer === 'B')
            //   ca = 2
            
            // if (ws[i].correct_answer === 'C')
            //   ca = 3
              
            // if (ws[i].correct_answer === 'D')
            //   ca = 4

            this.questions.push({
              question: ws[i].question,
              option1: ws[i].option1,
              option2: ws[i].option2,
              option3: ws[i].option3,
              option4: ws[i].option4,
              option5: ws[i].option5 ? ws[i].option5 : null,
              option6: ws[i].option6 ? ws[i].option6 : null,
              correct_answer: ws[i].correct_answer ? ws[i].correct_answer : null ,
              correct_answer2: ws[i].correct_answer2 ? ws[i].correct_answer2 : null ,
              correct_answer3: ws[i].correct_answer3 ? ws[i].correct_answer3 : null ,
              correct_answer4: ws[i].correct_answer4 ? ws[i].correct_answer4 : null ,
              correct_answer5: ws[i].correct_answer5 ? ws[i].correct_answer5 : null ,
              correct_answer6: ws[i].correct_answer6 ? ws[i].correct_answer6 : null ,
              explanation_text: ws[i].explanation_text
            });
            console.log(this.questions);
            //excelRecipientList
         //   excellist.push(ws[i]);
          }

          if(this.excelQuestions.length > 0){
           // this.uploadQuestions();
          }
        //  console.log("Read results", excellist); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
         // const a = workbook.Sheets[workbook.SheetNames[0]];
       //   const headers = this.getHeader(a);
        //  console.log("headers", headers);
          // Get header2-2
        } catch (e) {
          return alert("Read failure!");
        }
      };
      fileReader.readAsBinaryString(files[0]);
      // var input = document.getElementById("upload");
      // input.value = "";
    },

    closeQuestionModal() {
      this.$emit('closedQuestion');
    },
    pickExcel () {
      this.$refs.excelFile.click()     
    },
    pickThumbnail () {
      this.$refs.explanation.click()     
    },
	  onThumbnailPicked (event, index) {
      this.fileName = this.$refs.explanation.files[0].name;
      this.explanation = this.fileName
      this.questions[index].ext = this.fileName.substr(this.fileName.lastIndexOf(".") + 1);
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.questions[index].file = reader.result.split(',')[1]
      }
   }
  }
};
</script>
